export default "__VITE_ASSET__OtTY7Mn0__"